import React from 'react'
import NumberFormat from 'react-number-format'
import CustomPagination from '../../components/pagination'
import BeneficiaryDetails from '../../components/view-details/benificiary'
import BeneficiaryHeaderDetails from '../../components/header-details/benificiary'
import { Checkbox } from 'antd'
import { useTranslation } from 'react-i18next'
import { APPROVAL_COMMON_KEYS } from '../../utils/translation-constants'
import Loading from 'custom/assets/loaders/Loading'
import ViewComments from './../../components/comments-details/view-comment'

export default function BeneficiaryTab({
  roleAccessKey,
  dataSource = [],
  indeterminate,
  handleSelectAll,
  selectedRecords,
  handleMultiApproveSelect,
  handleMultiRejectSelect,
  minValue,
  maxValue,
  setExpanded,
  setTabIndex,
  handleCheckBoxChange,
  getBeneficiaryAuthComments,
  setMinValue,
  setMaxValue,
  checkAll,
  expanded,
  tabIndex,
  loading,
  authCommentsList = [],
  handleDeleteSelect,
  handleApproveSelect,
  handleRejectSelect,
}) {
  const { t } = useTranslation()

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  return (
    <>
      {roleAccessKey !== 'I' && roleAccessKey !== 'VW' && dataSource.length > 0 && (
        <div style={{ display: 'flex', justifyContent: 'space-between', paddingBottom: 15 }}>
          <Checkbox
            checked={checkAll}
            indeterminate={indeterminate}
            onChange={(e) => handleSelectAll(e.target.checked)}>
            {t(APPROVAL_COMMON_KEYS.SELECT_ALL)}
          </Checkbox>
          {selectedRecords.length > 0 && (
            <div className='d-flex approve-reject-btn'>
              <a onClick={() => handleMultiApproveSelect()}>
                {roleAccessKey === 'A'
                  ? t(APPROVAL_COMMON_KEYS.APPROVE)
                  : t(APPROVAL_COMMON_KEYS.VERIFY)}
              </a>
              <a onClick={() => handleMultiRejectSelect()}>{t(APPROVAL_COMMON_KEYS.REJECT)}</a>
            </div>
          )}
        </div>
      )}

      {dataSource.slice(minValue, maxValue).map((option, index) => (
        <div key={index} className='approval-card'>
          <div
            className=' '
            onClick={() => {
              setTabIndex(1)
              if (expanded == index) {
                setExpanded(null)
              } else {
                setExpanded(index)
              }
            }}>
            <div className='approval-card-header '>
              <span style={{ alignItems: 'center', display: 'flex' }}>
                <span style={{ marginRight: 10 }}>
                  {roleAccessKey !== 'I' && roleAccessKey !== 'VW' && (
                    <Checkbox
                      checked={option.isChecked}
                      onChange={(e) => {
                        setExpanded(null)
                        handleCheckBoxChange(e.target.checked, option)
                      }}></Checkbox>
                  )}
                </span>
                <span>
                  <span className='span1'>
                    {t(APPROVAL_COMMON_KEYS.ACCOUNT_NO)}. : {option?.beneAccNo}
                  </span>{' '}
                  <span className='mt-2 span2'>{option?.beneName}</span>
                </span>
              </span>
              <span>
                <span className='span3'>{option?.beneType}</span>
                <span className='mt-2 span2 text-right'>
                  {option?.initDate !== null ? option?.initDate : '-'}
                </span>
              </span>
            </div>
          </div>

          {expanded === index && (
            <div className='approval-card-body'>
              <div className='row tab-navbar'>
                <div className={tabIndex === 1 ? 'col-6 selected' : 'col-6'}>
                  <span
                    onClick={() => {
                      setTabIndex(1)
                    }}>
                    {t(APPROVAL_COMMON_KEYS.VIEW_DETAILS)}
                  </span>
                </div>
                <div className={tabIndex === 2 ? 'col-6 selected' : 'col-6'}>
                  <span
                    onClick={() => {
                      setTabIndex(2)
                      getBeneficiaryAuthComments(option)
                    }}>
                    {t(APPROVAL_COMMON_KEYS.VIEW_COMMENTS)}
                  </span>
                </div>
              </div>
              {tabIndex === 1 && (
                <div>
                  <BeneficiaryDetails option={option} />
                  <div className='d-flex' style={{ marginTop: 20, justifyContent: 'center' }}>
                    {roleAccessKey !== 'I' && roleAccessKey !== 'VW' && selectedRecords.length === 0 && (
                      <div className='d-flex'>
                        <a onClick={() => handleApproveSelect(option)}>
                          {roleAccessKey === 'A'
                            ? t(APPROVAL_COMMON_KEYS.APPROVE)
                            : t(APPROVAL_COMMON_KEYS.VERIFY)}
                        </a>
                        <a onClick={() => handleRejectSelect(option)}>
                          {t(APPROVAL_COMMON_KEYS.REJECT)}
                        </a>
                      </div>
                    )}
                    {roleAccessKey === 'I' && (
                      <a onClick={() => handleDeleteSelect(option)}>
                        {t(APPROVAL_COMMON_KEYS.DELETE)}
                      </a>
                    )}
                  </div>
                </div>
              )}
              {tabIndex === 2 && (
                <>
                  {loading && renderLoading()}
                  {authCommentsList.length === 0 && !loading && (
                    <div className='no-data-found'>
                      {t(APPROVAL_COMMON_KEYS.NO_COMMENTS_FOUND)}{' '}
                    </div>
                  )}
                  {authCommentsList.length > 0 && <ViewComments comments={authCommentsList} />}
                </>
              )}
            </div>
          )}
        </div>
      ))}

      {dataSource.length > 5 && (
        <div style={{ marginBottom: 30 }}>
          <CustomPagination
            defaultPageSize={5}
            setMaxValue={(value) => {
              setExpanded(null)
              setMaxValue(value)
            }}
            setMinValue={(value) => setMinValue(value)}
            totalLength={dataSource.length}
            defaultCurrent={1}
          />
        </div>
      )}
    </>
  )
}
